import {Component, computed, inject, input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Spinner} from '../../../../../../shared/components/spinner/spinner';
import {ResultsStore} from '../../../../../../shared/store/results.store';
import {IItem} from '../../../../../../types/IItem';

@Component({
  selector: 'app-results-table-row-price',
  standalone: true,
  imports: [CommonModule, Spinner],
  templateUrl: './results-table-row-price.component.html',
  styleUrl: './results-table-row-price.component.css'
})
export class ResultsTableRowPriceComponent {
  item = input.required<IItem>();
  resultsStore = inject(ResultsStore);

  hasCost = computed(() => this.item().availability.some(({ cost }) => cost > 0));

  range = computed(() => {
    const pricingData = this.item()
      .availability
      .map(({ cost }) => this.resultsStore.getPricing()(this.item().id, cost)?.price);

    const hasPulled = pricingData.some(price => price !== undefined);
    const prices = pricingData.filter((price): price is number => price != null && price > 0);

    if (prices.length === 0) {
      return hasPulled ? { min: null, max: null, hasPulled: true } : null;
    }

    const min = Math.min(...prices);
    const max = Math.max(...prices);

    return { min, max: max !== min ? max : null, hasPulled: true };
  });
}
